import BaseComponent from './basecomponent';

export default class FormValidation extends BaseComponent {
  constructor(element) {
    super(element);

    this.element.setAttribute('novalidate', 'novalidate');

    this.element.addEventListener('submit', this.onSubmit.bind(this));
  }

  onSubmit(e) {
    let requiredEls = Array.prototype.slice.call(this.element.querySelectorAll('[required]'), 0);
    let errorField = null;
    for (let el of requiredEls) {
      el.classList.remove('is-invalid');

      if (el.id === 'registration-form-mobilePhone') {
        const parentEl = $(el.parentElement);
        parentEl.removeClass('is-invalid');

        const invalidFeedback = parentEl.siblings('.invalid-feedback');
        if (invalidFeedback) {
          invalidFeedback.removeClass('d-block');
        }
      }

      if (el.id === 'registration-form-fiscalcode') {
        const nameInput = requiredEls.find((el) => el.id === 'registration-form-fname');
        const surnameInput = requiredEls.find((el) => el.id === 'registration-form-lname');
        const birthdateInput = requiredEls.find((el) => el.id === 'registration-form-bdate');
        const isFiscalCodeValid = this.validateFiscalCode(nameInput, surnameInput, birthdateInput, el).isCodiceFiscaleValid;

        if (!isFiscalCodeValid) { 
          el.classList.add('is-invalid');
          $(el).siblings('.invalid-feedback').html(el.dataset.invalidError || el.dataset.missingError);
        } else {
          el.classList.remove('is-invalid');
        }
      }

      if (el._error_container) {
        el._error_container.remove();
        delete el._error_container;
      }

      if (!el.checkValidity()) {
        errorField = errorField || el;

        let parentEl = ((el.id === 'complaintForm-phone' || el.id === 'contactForm-phone' || el.id === 'contactForm-adultsQuantity' || el.id === 'contactForm-childrenQuantity') ? el.parentElement.closest('.form-group') : el.parentElement);
        let errorEl = parentEl.querySelector('.invalid-feedback');
        if (errorEl && errorEl.innerHTML.trim()) {
          // already managed
          continue;
        }

        let p = errorEl || document.createElement('div');
        p.setAttribute('data-color', 'danger');
        p.classList.add('invalid-feedback');
        p.innerHTML = el.dataset.errorMessage || el.validationMessage;
        if (el.id === 'contactForm-phone'){
          parentEl.appendChild(p);
          el.classList.add('is-invalid');
          el._error_container = p;
          p.style.display = "block";
        } else if (el.id === 'complaintForm-phone'){
          parentEl.appendChild(p);
          el.closest('.intl-input-container').classList.add('is-invalid');
          el._error_container = p;
          p.style.display = "block";
        } else if (el.id === 'contactForm-textArea'){
          p.innerHTML = el.getAttribute('data-range-error');
          el.parentElement.appendChild(p);
          el.classList.add('is-invalid');
          el._error_container = p;
        } else if (el.id === 'contactForm-adultsQuantity' || el.id === 'contactForm-childrenQuantity'){
          parentEl.appendChild(p);
          el.classList.add('is-invalid');
          el._error_container = p;
          p.style.display = "block";
        } else if (el.id === 'registration-form-mobilePhone') {
          $(parentEl).addClass('is-invalid');
          const invalidFeedback = $(parentEl).siblings('.invalid-feedback');
          if (invalidFeedback) {
            invalidFeedback.toggleClass('d-block');
          }
        } else if (el.id === 'registration-form-bdate') {
          $(parentEl).addClass('is-invalid');
          const invalidFeedbackDate = $(parentEl).children('.invalid-feedback');
          if (invalidFeedbackDate) {
            el.classList.add('is-invalid');
            invalidFeedbackDate.html(el.dataset.invalidError);
            invalidFeedbackDate.addClass('d-block');
          }
        } else if (el.type === 'radio' && el.closest('.row-radio-travels')) {
          const group = el.closest('.row-radio-travels');
          const existing = group.nextElementSibling;
          el.classList.add('is-invalid');
          if (existing && existing.classList.contains('invalid-feedback')) {
            if (!existing.innerHTML.trim()) {
              existing.innerHTML = el.dataset.errorMessage || el.validationMessage;
            }
            existing.style.display = 'block';
            continue;
          }
          p.classList.add('js-radio-group-error');
          p.setAttribute('role', 'alert');
          p.style.display = 'block';
          group.insertAdjacentElement('afterend', p);
          el._error_container = p;
        } else {
          el.parentElement.appendChild(p);
          el.classList.add('is-invalid');
          el._error_container = p;
        }
      }
    }

    if (errorField) {
      try {
        /*errorField.scrollIntoView({
          behavior: 'smooth'
        });*/

        var offsetForNav = 50;
        if ($('nav.sticky-show').length) {
          offsetForNav = 150;
        }
        $('html, body').animate({ scrollTop: $(errorField).offset().top - offsetForNav }, 200);

      } catch (e) {
        console.warn(`scroll in to view error for`, errorField);
      }
      e.preventDefault();
    }

    return !errorField;
  }

  validateFiscalCode(name, surname, birthdate, fiscalCodeInput) {
    name = name.value.toUpperCase();
    surname = surname.value.toUpperCase();
    birthdate = birthdate.value;

    const fiscalCode = fiscalCodeInput && fiscalCodeInput.value.toUpperCase();

    let response = {};

    const setInvalidResponse = () => {
        response.isCodiceFiscaleValid = false;
        response.fiscalCode = fiscalCodeInput;
        response.fiscalCode.valid = false;
        return response;
    };

    if (fiscalCode === '') {
        if (fiscalCodeInput.mandatory) {
            response.isRequiredCF = true;
        } else {
            response.isCodiceFiscaleValid = true;
            response.fiscalCode = fiscalCodeInput;
            response.fiscalCode.valid = true;

            return response;
        }
    }

    if (fiscalCode.length !== 16) {
        return setInvalidResponse();
    }

    const yearCode = fiscalCode.substr(6, 2);
    const monthCode = fiscalCode.substr(8, 1);
    const dayCode = fiscalCode.substr(9, 2);

    const inputDate = new Date(birthdate);
    const inputYear = inputDate.getFullYear() % 100;
    const inputMonth = inputDate.getMonth();
    const inputDay = inputDate.getDate();

    const monthCodes = {
        'A': 0, // January
        'B': 1,
        'C': 2,
        'D': 3,
        'E': 4,
        'H': 5,
        'L': 6,
        'M': 7,
        'P': 8,
        'R': 9,
        'S': 10,
        'T': 11  // December
    };

    const fiscalCodeYear = parseInt(yearCode, 10);
    const fiscalCodeMonth = monthCodes[monthCode];
    const fiscalCodeDay = parseInt(dayCode, 10);

    const dateMatches =
        inputYear === fiscalCodeYear &&
        inputMonth === fiscalCodeMonth &&
        (inputDay === fiscalCodeDay || inputDay === (fiscalCodeDay - 40)); // Women have 40 added to day

    if (!dateMatches) {
        return setInvalidResponse();
    }

    const surnamePortion = fiscalCode.substring(0, 3);
    const namePortion = fiscalCode.substring(3, 6);

    function getConsonants(str) {
        return str.replace(/[AEIOU\s]/g, '');
    }

    function getVowels(str) {
        return str.replace(/[^AEIOU]/g, '');
    }

    function generatePortion(str, isSurname) {
        const consonants = getConsonants(str);
        const vowels = getVowels(str);
        let result = '';

        if (isSurname) {
            if (consonants.length >= 3)
                result = consonants.substring(0, 3);
            else
                result = (consonants + vowels + 'XXX').substring(0, 3);
        } else {
            if (consonants.length >= 4)
                result = consonants[0] + consonants[2] + consonants[3];
            else if (consonants.length >= 3)
                result = consonants.substring(0, 3);
            else
                result = (consonants + vowels + 'XXX').substring(0, 3);
        }

        return result;
    }

    const expectedSurnamePortion = generatePortion(surname, true);
    const expectedNamePortion = generatePortion(name, false);

    if (surnamePortion !== expectedSurnamePortion || namePortion !== expectedNamePortion) {
        return setInvalidResponse();
    }

    let validi = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    let set1 = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    let set2 = "ABCDEFGHIJABCDEFGHIJKLMNOPQRSTUVWXYZ";
    let setpari = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    let setdisp = "BAKPLCQDREVOSFTGUHMINJWZYX";
    let s = 0;

    for (let i = 0; i < 16; i++) {
        if (validi.indexOf(fiscalCode.charAt(i)) === -1) {
            return setInvalidResponse();
        }
    }

    for (let i = 1; i <= 13; i += 2) {
        s += setpari.indexOf(set2.charAt(set1.indexOf(fiscalCode.charAt(i))));
    }

    for (let i = 0; i <= 14; i += 2) {
        s += setdisp.indexOf(set2.charAt(set1.indexOf(fiscalCode.charAt(i))));
    }

    if (s % 26 === fiscalCode.charCodeAt(15) - 'A'.charCodeAt(0)) {
        response.isCodiceFiscaleValid = true;
        response.isRequiredCF = false;
        response.fiscalCode = fiscalCodeInput;
        response.fiscalCode.valid = true;
    } else {
        return setInvalidResponse();
    }

    return response;
  }

  _destroy() {}
}
